<template>
    <hm-content title="">
        <h3 v-if="searchCondition.badgeName" style="margin: 0;font-size: 14px;font-weight: 400;color: #E50065;margin-bottom: 10px;">{{searchCondition.badgeName}}</h3>
        <div class="hm-radio-group">
            <el-radio-group
                v-model="searchCondition.collectionState"
                size="small"
                @change="switchTab"
            >
                <el-radio-button label=""
                >全部({{ Number(stateCount.yes_count) + Number(stateCount.no_count) || 0 }})</el-radio-button
                >
                <el-radio-button label="yes">
                已领取({{ stateCount.yes_count || 0 }})
                </el-radio-button>
                <el-radio-button label="no">
                未领取({{ stateCount.no_count || 0 }})
                </el-radio-button>
            </el-radio-group>
        </div>
      <div class="table-panel flex flex-end">
        <div>
         <el-select
            clearable
            class="mr10"
            size="small"
            v-model="searchCondition.collectionState"
            placeholder="领取状态"
          >
            <el-option
              label="已领取"
              value="yes"
            ></el-option>
                <el-option
                label="未领取"
                value="no"
            ></el-option>
          </el-select>

          <el-input
            clearable
            v-model.trim="searchCondition.badgeName"
            placeholder="请输入活动名称"
            size="small"
            class="ipt mr10"
          ></el-input>

          <el-date-picker
            v-model="searchCondition.medalCycleTime"
            type="datetimerange"
            size="small"
            clearable
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
            style="margin-right: 10px"
            >
          </el-date-picker>

          <el-select v-model="searchCondition.badgeBenefitType" placeholder="请选择权益类型" size="small" style="margin-right: 10px;" clearable>
            <el-option
              v-for="item in rightsList"
              :key="item.value"
              :label="item.itemText"
              :value="item.itemValue">
            </el-option>
          </el-select>
          

          <el-input
            clearable
            style="width: 250px"
            v-model.trim="searchCondition.guiderName"
            placeholder="请输入导购姓名/手机号"
            size="small"
            class="ipt mr10"
          ></el-input>
     
          
          <!-- 勋章类型 -->
          <!-- <el-select v-model="badgeType" placeholder="请选择勋章类型" size="small" clearable style="margin-right: 10px">
              <el-option
                v-for="item in medalTypeList"
                :key="item.value"
                :label="item.itemText"
                :value="item.itemValue">
              </el-option>
            </el-select> -->
  
  
         
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
  
     
      <el-table :data="list" style="width: 100%" stripe border size="small">
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
  
        <el-table-column
          header-align="center"
          align="center"
          prop="badgeName"
          label="活动名称"
          width="200"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="badgeBenefitRelList"
          label="权益名称"
          key="gameType"
        >
          <template slot-scope="scope">
            <div v-for="item in scope.row.badgeBenefitRelList" :key="item.value">  {{ item.badgeBenefitName + item.badgeBenefitValue }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderName"
          label="导购姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="guiderPhone"
          label="导购手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="发放时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="badgeBenefitRelList"
          label="权益类型"
        >
            <template slot-scope="scope">
                <div v-for="item in scope.row.badgeBenefitRelList" :key="item.value">  {{ item.badgeBenefitName}}</div>    
            </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="useState"
          label="权益状态"
        >
            <template slot-scope="scope">
               <p v-if="scope.row.useState == 'unuse'">未使用</p>
               <p v-if="scope.row.useState == 'used'" style="color: #67C23A;">使用中</p>
               <p v-if="scope.row.useState == 'stop'" style="color: #E50065;">已停用</p>
            </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="collectionState"
          label="领取状态"
        >
        <template slot-scope="scope">
            <div>{{scope.row.collectionState == 'yes' ? '已领取':'未领取' }}</div>
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="collectionTime"
          label="领取时间"
        >
        <template slot-scope="scope">
            <div>{{scope.row.collectionTime == null ? '暂无数据': scope.row.collectionTime }}</div>
        </template>
        </el-table-column>
        <el-table-column
          width="250"
          label="操作"
          header-align="center"
          align="left"
        >
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
  
              <el-button
                size="small"
                type="text"
                @click="theBenefitUsageDetailMethod(scope.row)"
                >权益使用明细</el-button
              >
           
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 权益使用明细 -->
      <el-dialog title="权益使用明细"  :visible.sync="breakdownOfBenefitsShow" size="small">
       <div style="min-height: 400px; padding-bottom: 40px;">
            <div>
            <el-radio-group size="small" v-model="breakdownOfBenefitsDatas.badgeBenefitType" @change="detailToggleMenu">
              <el-radio-button 
              v-for="item in rightsList"
              :key="item.value"
              size="small"
              :label="item.itemValue">
              {{item.itemText}}
            </el-radio-button>
            </el-radio-group>
          </div>
        <el-table v-show="instantCashBreakdowns" :data="breakdownOfBenefitsList" header-align="center" stripe border size="small" style="margin-top: 5px;">
          <el-table-column type="index" align="center" :index="index => index + (currentPagePart1 - 1) * pageSize1 + 1" label="序号" width="50"></el-table-column>
          <el-table-column property="useTime" align="center" label="使用时间" width="150"></el-table-column>
          <el-table-column property="distributionCode" align="center" label="极速券编码" width="200"></el-table-column>
          <el-table-column property="useDeclareSn" align="center" label="申报单号"></el-table-column>
          <el-table-column property="count" align="center" label="消耗次数">
            <template slot-scope="scope">
                <div>{{scope.row.count}}次</div>
            </template>
          </el-table-column>
        </el-table>
        
        <el-table v-show="!instantCashBreakdowns" :data="cashBreakdownList" header-align="center" stripe border size="small" style="margin-top: 5px;">
            <el-table-column type="index" align="center" :index="index => index + (currentPagePart1 - 1) * pageSize1 + 1" label="序号" width="50"></el-table-column>
            <el-table-column property="useTime" align="center" label="使用时间" width="150"></el-table-column>
            <el-table-column property="distributionCode" align="center" label="现金奖励编码" width="200"></el-table-column>
            <el-table-column property="getMoneyType" align="center" label="提现状态"></el-table-column>
            <el-table-column property="count" align="center" label="提现金额">
                <template slot-scope="scope">
                    <div>{{scope.row.count}}元</div>
                </template>
            </el-table-column>
        </el-table>


        <div class="bright_subdivision_page">
            <el-pagination
              background
              :total="totalPart1"
              @size-change="handleSizeChangePart1"
              @current-change="pagingPart1"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart1"
            ></el-pagination>
        </div>


       </div>


      </el-dialog>



      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <el-dialog
        title="请用微信扫一扫"
        :visible.sync="qrcodeDialogVisible"
        :modal="false"
        width="250px"
      >
        <div class="qrcode-wrapper">
          <img style="width: 100%" :src="activityCode" alt="二维码" />
        </div>
      </el-dialog>
      <el-dialog
        :close-on-click-modal="false"
        title="参与活动记录"
        width="1200px"
        :visible.sync="dialogVisibleReservition"
      >
        <div class="mb10 flex flex-between">
          <el-radio-group
            v-model="spreadLogType"
            size="small"
            @change="recordTypeTab"
          >
            <el-radio-button label="1">邀请记录</el-radio-button>
            <el-radio-button label="2">红包领取记录</el-radio-button>
          </el-radio-group>
          <div>
            <el-input
              clearable
              style="width: 250px"
              v-model.trim="memberMobile"
              placeholder="请输入手机号"
              size="small"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchPart"
              >查询</el-button
            >
            <el-button
              type="success"
              size="small"
              @click="
                outputPart(spreadLogType === '1' ? '邀请记录' : '红包领取记录')
              "
              :loading="isOutputing"
              >导出</el-button
            >
          </div>
        </div>
        <div>
          <div class="flex mb10" v-if="spreadLogType === '2'">
            <div class="mr20">
              已发放红包
              <span class="primary">{{ redpackageMoneyInfo.sendMoney }}元</span>
            </div>
            <div class="mr20">
              红包限制
              <span class="primary">{{ redpackageMoneyInfo.totalMoney }}元</span>
            </div>
            <div class="mr20">
              剩余
              <span class="primary"
                >{{ redpackageMoneyInfo.surplusMoney }}元</span
              >
            </div>
          </div>
          <el-table
            :data="participateList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
            v-if="spreadLogType === '1'"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
            ></el-table-column>
            <!-- <el-table-column
              header-align="center"
              align="center"
              prop="gameType"
              label="活动类型"
              width="180"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.spreadTarget == 'guider'"
                  >导购邀请供应商奖励活动</span
                >
                <span v-else-if="scope.row.spreadTarget == 'supplier'"
                  >业务员邀请供应商奖励活动</span
                >
                <span v-else-if="scope.row.spreadTarget == 'store'"
                  >采购邀请供应商奖励活动</span
                >
              </template>
            </el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="spreadName"
              label="活动名称"
              key="spreadName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="参与手机号"
              prop="memberMobile"
              key="memberMobile"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="参与者姓名"
              prop="memberName"
              key="memberName"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="参与时间"
              prop="shareTime"
              key="shareTime"
            >
            </el-table-column>
          </el-table>
          <el-table
            :data="participateList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
            v-else
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="gameType"
              label="活动类型"
              width="180"
              key="gameType"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.spreadTarget == 'guider'"
                  >导购邀请供应商奖励活动</span
                >
                <span v-else-if="scope.row.spreadTarget == 'supplier'"
                  >业务员邀请供应商奖励活动</span
                >
                <span v-else-if="scope.row.spreadTarget == 'store'"
                  >采购邀请供应商奖励活动</span
                >
                <span v-else-if="scope.row.spreadTarget == 'redpackageVideoAd'"
                  >微信广告激励红包</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="spreadName"
              label="活动名称"
              key="spreadName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="邀请者奖励金额"
              prop="shareRewardMoney"
              key="shareRewardMoney"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiveRewardMoney"
              label="被邀请者奖励金额"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shareInfo"
              label="邀请者信息"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="receiveInfo"
              label="被邀请者手机号"
            ></el-table-column>
          </el-table>
          
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalPart"
              @size-change="handleSizeChangePart"
              @current-change="pagingPart"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="活动上线操作"
        :visible.sync="onlineDialogVisible"
        :close-on-click-modal="false"
      >
        <el-form
          :model="ruleForm"
          :rules="rule"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item label="上线验证码" prop="verificationCode">
            <el-input
              style="width: 300px"
              size="small"
              clearable
              class="mr10 ipt"
              maxlength="25"
              v-model.trim="ruleForm.verificationCode"
              placeholder="请输入验证码"
            ></el-input>
            <el-button @click="send" size="small" type="primary">
              {{ show ? "发送" : `${time}秒后获取` }}
            </el-button>
            <div class="form-item-tip">
              点击发送验证码会给禾苗管理账户邮箱发送一个验证码 <br />
              请向管理人员索取后验证提交
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="submitForm('ruleForm')" size="small" type="primary">
            确 认</el-button
          >
          <el-button size="small" @click="onlineDialogVisible = false"
            >取 消</el-button
          >
        </span>
      </el-dialog>
    </hm-content>
  </template>
  
  <script>
export default {
  components: {},
  data() {
    return {
      instantCashBreakdowns: true,
      cashBreakdownList:[],
      breakdownOfBenefitsShow: false,
      breakdownOfBenefitsDatas:{
        pageNo: 1,
        pageSize: 10,
        badgeBenefitType:'speed_declare',
        badgeId : "",
        guiderId: "",
      },
      breakdownOfBenefitsList:[],
      medalCycleTime:[],
      redpackageMoneyInfo: {},
      show: true,
      onlineDialogVisible: false,
      spreadLogType: "1",
      participateList: [],
      totalPart: 0,
      totalPart1: 0,
      currentPagePart: 1,
      currentPagePart1: 1,
      pageSizePart: 10,
      dialogVisibleReservition: false,
      gameTypeList: [
        {
          gameName: "导购邀请供应商奖励活动",
          gameCode: "guider",
        },
        {
          gameName: "业务员邀请供应商奖励活动",
          gameCode: "supplier",
        },
        {
          gameName: "采购邀请供应商奖励活动",
          gameCode: "store",
        },
        {
          gameName: "微信广告激励红包",
          gameCode: "redpackageVideoAd",
        },
      ],
      activityCode: "",
      qrcodeDialogVisible: false,
      isOutputing: false,
      stateCount: {},
      currentPage: 1,
      pageSize: 10,
      pageSize1:10,
      total: 0,
      list: [],
      memberMobile: "",
      searchCondition: {
        collectionState:'',
        badgeName:'',
        medalCycleTime:'',
        badgeBenefitType:'',
        guiderName:'',
        startCreateTime:'',
        endCreateTime:''
      },
      ruleForm: {
        verificationCode: "",
      },
      rule: {
        verificationCode: {
          required: true,
          message: "请输入验证码",
        },
      },
      row: {},
      time: 59,
      timer: "",
      rightsList:[]
    };
  },
  computed: {},
  watch: {},
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    // end 转成yyyy-MM-dd HH:mm:ss格式
    const endStr = end.getFullYear() + "-" + (end.getMonth() + 1) + "-" + end.getDate() + " " + end.getHours() + ":" + end.getMinutes() + ":" + end.getSeconds();
    // start 转成yyyy-MM-dd HH:mm:ss格式
    const startStr = start.getFullYear() + "-" + (start.getMonth() + 1) + "-" + start.getDate() + " " + start.getHours() + ":" + start.getMinutes() + ":" + start.getSeconds();
    this.searchCondition.medalCycleTime = [startStr, endStr];
    this.medalsModule();
    this.theTypeOfRedPacketBenefit();
  },
  mounted() {
    if (this.$route.query.badgeName) {
        this.searchCondition.badgeName = this.$route.query.badgeName;
      }
      this.queryList();
  },
  methods: {
    sequenceNumber(index){
        index++;
        return index;
    },
    // 红包勋章下拉
    async getTheRedEnvelopeMedal() {
      const { result } = await this.$store.dispatch("queryReportDataSource2");
      if (result) {
        this.medalTypeList = result;
      }
    },
    medalsModule() {
    
    },
    
    async send() {
      if (this.show) {
        const { code } = await this.$store.dispatch(
          "redpackageSpreadSendOnlineMail",
          {
            spreadId: this.row.id,
          }
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.time = 59;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.time < 1) {
              clearInterval(this.timer);
              this.show = true;
            } else {
              --this.time;
            }
          }, 1000);
        }
      }
    },
    async submitForm(formName) {
        console.log(formName)
      const valid = await this.$refs[formName].validate();
      if (valid) {
        let params = {
          spreadId: this.row.id,
          enabledState: "yes",
          verificationCode: this.ruleForm.verificationCode,
        };
        const { code } = await this.$store.dispatch(
          "updateSpreadAcitivityEnabledState",
          params
        );
        if (code === "0") {
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          this.ruleForm.verificationCode = "";
          this.onlineDialogVisible = false;
          this.show = true;
          clearInterval(this.timer);
          this.time = 0;
          this.queryList();
        }
      } else {
        return false;
      }
    },
    pagingPart(page) {
      this.currentPagePart = page;
      this.quertReservitionList();
    },
    // 明细列表分页
    pagingPart1(page) {
      this.currentPagePart1 = page;
      this.theBenefitUsageDetailMethod();
    },
    recordTypeTab() {
      this.participateList = [];
      this.totalPart = 0;
      this.pageSizePart = 10;
      this.currentPagePart = 1;
      this.quertReservitionList();
    },
    handleSizeChangePart(size) {
      this.currentPagePart = 1;
      this.pageSizePart = size;
      this.quertReservitionList();
    },
    handleSizeChangePart1(size) {
      this.currentPagePart1 = 1;
      this.breakdownOfBenefitsDatas.pageSize = size;
      this.pageSize1 = size;
      this.theBenefitUsageDetailMethod();
    },
    searchPart() {
      this.currentPagePart = 1;

      this.quertReservitionList();
    },
    edit(row) {
      let name = "";
      if (row.spreadTarget === "redpackageVideoAd") {
        name = "SettingRedActNew";
      } else {
        name = "SettingRedAct";
      }
      this.$router.push({
        name: name,
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "edit",
        },
      });
    },
    toDetails(row) {
      let name = "";
      if (row.spreadTarget === "redpackageVideoAd") {
        name = "SettingRedActNew";
      } else {
        name = "SettingRedAct";
      }
      this.$router.push({
        name: name,
        query: {
          id: row.id,
          spreadTarget: row.spreadTarget,
          type: "details",
        },
      });
    },
    detailToggleMenu(val){
        if(val == 'speed_declare'){
            this.instantCashBreakdowns = true;
        }else {
            this.instantCashBreakdowns = false;
        }
        this.currentPagePart1 = 1;
        this.breakdownOfBenefitsDatas.queryBenefitUseRecordGroup = val;
        this.theBenefitUsageDetailMethod();
    },
    // 权益使用明细
    theBenefitUsageDetailMethod(row) {
        if(row){
            this.row = row;
        }
      this.breakdownOfBenefitsShow = true;
      this.breakdownOfBenefitsDatas.badgeId = this.row.badgeId;
      this.breakdownOfBenefitsDatas.guiderId = this.row.guiderId;
      this.breakdownOfBenefitsDatas.pageNo = this.currentPagePart1;
      let params = this.breakdownOfBenefitsDatas;
        this.$store.dispatch("queryBenefitUseRecordGroup", params)
            .then((res) => {
                const { code, result } = res;
                const { records, total } = result;
                if (code === "0") {
                    if(this.breakdownOfBenefitsDatas.badgeBenefitType == 'speed_declare'){
                        this.breakdownOfBenefitsList = records;
                    }else {
                        this.cashBreakdownList = records;
                    }
                    this.totalPart1 = total;
                }
            });
     
    },
    copy(row) {
      let name = "";
      if (row.spreadTarget === "redpackageVideoAd") {
        name = "SettingRedActNew";
      } else {
        name = "SettingRedAct";
      }
      this.$router.push({
        name: name,
        query: {
          spreadTarget: row.spreadTarget,
          id: row.id,
          type: "copy",
        },
      });
    },
    // async productQrcode(row) {
    //   let path = `/pages/invitation/invitation?id=${row.id}`;

    //   const { result } = await this.$store.dispatch("createCouponQrcode", {
    //     path
    //   });
    //   this.qrcodeDialogVisible = true;
    //   this.activityCode = result;
    // },
    async quertReservitionList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType,
      };
      if (this.spreadLogType === "1") {
        params.shareMobile = this.memberMobile;
      } else {
        params.keyWord = this.memberMobile;
      }
      // let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryRedpackageSpreadActivityLog",
        params
      );
      if (this.spreadLogType === "1") {
        const { records, total } = result;
        this.participateList = records;
        this.totalPart = total;
      } else {
        const { logDataInfoList, redpackageMoneyInfo } = result;
        this.redpackageMoneyInfo = redpackageMoneyInfo;
        const { records, total } = logDataInfoList;
        this.participateList = records;
        this.totalPart = total;
      }
      this.$nextTick(() => {
        this.$refs.tablePart.doLayout();
        //给table加一个ref
      });
    },
    async quertReservitionAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        spreadId: this.row.id,
        spreadLogType: this.spreadLogType,
      };
      // let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch(
        "queryAllRedpackageSpreadActivityLog",
        params
      );
      return this.spreadLogType === "1"
        ? result.records
        : result.logDataInfoList.records;
    },
    toReservitionList(row) {
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.spreadLogType = "1";
      this.quertReservitionList();
      this.dialogVisibleReservition = true;
    },
    outputPart(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.quertReservitionAllList()
          .then((res) => {
            const list = res;
            // if (this.participateType === "participate") {
            //   list.forEach(v => {
            //     v.isDefaultWinner = v.isDefaultWinner === "yes" ? "是" : "否";
            //     v.memberInfo = v.memberName + "/" + v.memberMobile;
            //     v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
            //   });
            // } else {
            //   list.forEach(v => {
            //     v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
            //     v.winningType =
            //       v.winningType === "manual" ? "手动开奖" : "自动开奖";
            //     v.memberInfo = v.memberName + "/" + v.memberMobile;
            //   });
            // }

            const tHeader = this.$refs.tablePart.columns
              .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter((o) => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.tablePart.$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },



    // 导出
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
          .then((res) => {
            console.log(res);
            const list = res;
            list.forEach((v) => {
              if (v.spreadTarget === "guider") {
                v.gameType = "邀请导购";
              } else if (v.spreadTarget === "supplier") {
                v.gameType = "邀请业务员";
              } else if (v.spreadTarget === "store") {
                v.gameType = "邀请采购";
              }
              if (v.enabledState === "yes") {
                v.enabledState = "上线";
              } else {
                v.enabledState = "下线";
              }
            });
            const tHeader = this.$refs.table.columns
              .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter((o) => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "我的活动" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 导出
    async queryAllList() {
      let params = {
      };
      if(this.searchCondition.medalCycleTime){
        this.searchCondition.startCreateTime = this.searchCondition.medalCycleTime[0];
        this.searchCondition.endCreateTime = this.searchCondition.medalCycleTime[1];
      }else {
        this.searchCondition.startCreateTime = '';
        this.searchCondition.endCreateTime = '';
      }
     
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "exportGuiderBenefitUseRecord",
        params
      );

      if (code === "0") {
        return result.pageList.records;
      }
    },
    
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      if(this.searchCondition.medalCycleTime){
        this.searchCondition.startCreateTime = this.searchCondition.medalCycleTime[0];
        this.searchCondition.endCreateTime = this.searchCondition.medalCycleTime[1];
      }else {
        this.searchCondition.startCreateTime = '';
        this.searchCondition.endCreateTime = '';
      }
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryBenefitUseRecordPage",
        params
      );

      if (code === "0") {
        const { useRecordStatisticsData, useRecordStatisticsCount } = result;
        this.stateCount = useRecordStatisticsCount;
        const { records, total } = useRecordStatisticsData;


        // 权益名称
        records.forEach(e=>{
            e.badgeBenefitRelList.forEach(r=>{
                if(r.badgeBenefitType == "speed_declare"){
                    r.badgeBenefitValue = r.badgeBenefitValue+'次';
                }

                if(r.badgeBenefitType == "money"){
                    r.badgeBenefitValue = r.badgeBenefitValue+'元';
                }
                this.rightsList.forEach(l=>{
                    if(l.itemValue == r.badgeBenefitType){
                        r['badgeBenefitName'] = l.itemText;
                    }
                })
            })
        })
        console.log(records)

        this.list = records;
        this.total = total;
      }
    },

    // 红包权益类型redpackage_badge_benefit_type
    async theTypeOfRedPacketBenefit(){
    const {result} = await this.$store.dispatch('queryReportDataSource3')
    if(result){
        this.rightsList = result;
    }
    },
    
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    // 查询
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async preInspectionRedpackageSpreadActivity(id) {
      let params = {
        id,
      };
      const { code, result } = await this.$store.dispatch(
        "preInspectionRedpackageSpreadActivity",
        params
      );
      if (code === "0") {
        if (result === "success") {
          this.onlineDialogVisible = true;
        }
      }
    },
  },
};
</script>
  <style lang="scss" scoped>
    .bright_subdivision_page {
        position: absolute;
        bottom: 10px;
        left: 27%;
    }
 </style>
